import React, { useContext } from "react";
import { contextapi } from "../../helpers/contextapi";

const Profile = () => {
  const context = useContext(contextapi);
  const { firstname, middlename, lastname, photo, studentid } = context?.values?.student;

  return (
    <div className="student-registration-container">
      {/* Profile Card */}
      <div className="profile-card">
        <div className="profile-header">
          <div className="avatar-container">
            <img
              src={photo?.link || "https://ui-avatars.com/api/?name=" + encodeURIComponent(firstname + " " + lastname)}
              alt={`${firstname} ${lastname}`}
              className="profile-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://ui-avatars.com/api/?name=" + encodeURIComponent(firstname + " " + lastname);
              }}
            />
            <span className="online-status"></span>
          </div>
        </div>

        <div className="registration-profile-content">
          <h2 className="student-name">
            {firstname} {middlename} {lastname}
          </h2>
          <p className="student-id">{studentid}</p>
        </div>
      </div>
    </div>
  );
};


export default Profile;
